module.exports = __webpack_public_path__ + "static/media/two-families.f8f55153.jpg";